import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useUpdateEstView(
  briefId?: string,
  handleCallback?: () => void
) {
  const {
    mutate: updateEstView,
    isLoading: isUpdating,
    isSuccess: isUpdated,
    error: updateEstViewError,
  } = useMutation({
    mutationFn: (data: { briefInfluencerId: string; estViews: number }) =>
      BriefService.updateEstView(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      handleCallback?.();
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", briefId],
      });
    },
  });

  return {
    updateEstView,
    isUpdating,
    isUpdated,
    updateEstViewError,
  };
}
